module.exports = __webpack_public_path__ + "img/san-petrus.0c6a06bb.png";